import {AxiosServer} from '../../utils';

const HOME = 'home/set';

const home_SET = (text) => {		
	return{
			type:HOME,
			payload:text
		} 
}

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});


const home_totalbyday_GET =(value)=>(dispatch,getState)=>{
	
	let Axios = AxiosServer();
	return  Axios.post('/api/rpt/totalbyday',value).then((res)=>{			
	   
	   if (res.data.status===false){
		   return '失败'
	   }else{
		   dispatch(home_SET({data:res.data.data}));
		   return '成功'
	   }	   
	   
	}).catch((err)=>{
		//dispatch({type:'login/set',payload:{loading:false}});
		console.log('err:',err);
	});	
	
}

const home_totaldfxuser_GET =(value)=>(dispatch,getState)=>{
	
	let Axios = AxiosServer();
	return  Axios.post('/api/rpt/totaldfxuser',value).then((res)=>{			
	   
	   if (res.data.status===false){
		   return '失败'
	   }else{
		   dispatch(home_SET({totalUserData:res.data.data}));

		   return '成功'
	   }	   
	   
	}).catch((err)=>{
		//dispatch({type:'login/set',payload:{loading:false}});
		console.log('err:',err);
	});	
	
}


export {HOME,home_SET,home_totalbyday_GET,home_totaldfxuser_GET };